import { combineReducers } from "redux";
import showSideBarReducer from "./reducers/admin/showSideBarReducer";
import userReducer from "./reducers/auth/authReducer";
import changePasswordReducer from "./reducers/auth/changePassReducer";
import changePassModalReducer from "./reducers/auth/changePassModalReducer";
import editProfileModalReducer from "./reducers/auth/editProfileModalReducer";
import editProfileReducer from "./reducers/auth/editProfileReducer";
import forgotPasswordReducer from "./reducers/auth/forgotPassReducer";
import newPasswordReducer from "./reducers/auth/newPassReducer";
import userListingReducer from "./reducers/admin/userLisitingReducer";
import userDetailsReducer from "./reducers/admin/userDetailsReducer";
import categoryModalReducer from "./../features/category/redux/categoryModalReducer"
import categoryReducer from "./../features/category/redux/categoryReducer"
import attributeModalReducer from "./../features/category/redux/attributeModalReducer"
import attributeReducer from "./../features/category/redux/attributeReducer"
import planModelReducer from "./../features/plans/redux/plamModalReducer"
import planReducer from "./../features/plans/redux/planReducer"
import vehiclesModelReducer from "./../features/vehicles/redux/vehiclesModalReducer"
import vehiclesReducer from "./../features/vehicles/redux/vehiclesReducer"
import settingsModelReducer from "./../features/settings/redux/settingsModalReducer"
import settingsReducer from "./../features/settings/redux/settingsReducer"
import makeModelReducer from "./../features/make/redux/makeModalReducer"
import makeReducer from "./../features/make/redux/makeReducer"
import blogModelReducer from "./../features/blog/redux/blogModalReducer"
import blogReducer from "./../features/blog/redux/blogReducer"
import faqsModalReducer from "./../features/faqs/redux/faqsModalReducer"
import faqsReducer from "./../features/faqs/redux/faqsReducer"
import contactUsModalReducer from "./../features/contact-us/redux/contactUsModalReducer"
import contactUsReducer from "./../features/contact-us/redux/contactUsReducer"

import adReportModalReducer from "./../features/ad-reports/redux/adReportModalReducer"
import adReportReducer from "./../features/ad-reports/redux/adReportUsReducer"



//Combining the reducer's into a rootReducer
const RootReducer = combineReducers({
    sidebar: showSideBarReducer,
    auth:userReducer,
    userListing:userListingReducer,
    changePassword:changePasswordReducer,
    newPassword:newPasswordReducer,
    forgotPassword:forgotPasswordReducer,
    changePassModalReducer:changePassModalReducer,
    editProfileModalReducer:editProfileModalReducer,
    editProfile:editProfileReducer,
    userDetails:userDetailsReducer,
    categoryModalReducer,
    categoryReducer,
    attributeModalReducer,
    attributeReducer,
    planModelReducer,
    planReducer,
    vehiclesModelReducer,
    vehiclesReducer,
    settingsModelReducer,
    settingsReducer,
    makeModelReducer,
    makeReducer,
    blogModelReducer,
    blogReducer,
    faqsModalReducer,
    faqsReducer,
    contactUsModalReducer,
    contactUsReducer,
    adReportModalReducer,
    adReportReducer,

});


export default RootReducer;